import { render } from "./user-match.vue?vue&type=template&id=72a98b35"
import script from "./user-match.vue?vue&type=script&lang=js"
export * from "./user-match.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__